export enum RoundStatus {
  OPENED = 'OPENED',
  CLOSED = 'CLOSED',
  PENDING = 'PENDING',
  RESULTED = 'RESULTED',
  COMPLETED = 'COMPLETED',
}
